import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';

export interface IState {
    searchKeywords: string;
}

export enum Actions {
    SearchKeywordsChanged = "SearchKeywordsChanged"
}


interface SearchKeywordsChangedAction {
    type: Actions.SearchKeywordsChanged;
    keywords: string;
}

type KnownAction = SearchKeywordsChangedAction;

export const actionCreators = {
    updateSearchKeywords: (keywords: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: Actions.SearchKeywordsChanged, keywords: keywords });
    }
}

const unloadedState: IState = {
    searchKeywords: ''
};

export const reducer: Reducer<IState> = (state: IState | undefined, incomingAction: Action): IState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {

        case Actions.SearchKeywordsChanged:

            return {
                ...state,
                searchKeywords: action.keywords
            };        
    }

    return state;
};